import { ILaya } from "../../ILaya";
import { LayaEnv } from "../../LayaEnv";
import { Event } from "../events/Event";
import { PAL } from "../platform/PlatformAdapters";
import { AssetDb } from "../resource/AssetDb";
import { Browser } from "../utils/Browser";
import { SpriteUtils } from "../utils/SpriteUtils";
export class VideoPlayerBackend {
    constructor() {
        this.options = {};
        this.allowBackground = false;
        this._playing = false;
        this._loaded = false;
        this._autoResume = false;
    }
    get currentTime() {
        return 0;
    }
    set currentTime(value) {
    }
    get volume() {
        return 0;
    }
    set volume(value) {
    }
    get muted() {
        return false;
    }
    set muted(value) {
    }
    get duration() {
        return 0;
    }
    get ended() {
        return false;
    }
    get loop() {
        return false;
    }
    set loop(value) {
    }
    get playbackRate() {
        return 1;
    }
    set playbackRate(value) {
    }
    get paused() {
        return false;
    }
    attachTo(owner) {
        if (this._owner) {
            this._owner.off(Event.TRANSFORM_CHANGED, this, this.onTransformChanged);
            ILaya.stage.off(Event.RESIZE, this, this.onTransformChanged);
        }
        this._owner = owner;
        if (this._owner) {
            this._owner.on(Event.TRANSFORM_CHANGED, this, this.onTransformChanged);
            ILaya.stage.on(Event.RESIZE, this, this.onTransformChanged);
        }
    }
    load(url) {
        if (!url)
            return;
        AssetDb.inst.resolveURL(url, url2 => this.onLoad(url2));
    }
    play() {
        if (this._playing || !LayaEnv.isPlaying)
            return;
        this._playing = true;
        ILaya.stage.on(Event.BLUR, this, this.onBlur);
        if (this._loaded)
            this.onPlay();
    }
    pause() {
        this._autoResume = false;
        if (!this._playing)
            return;
        this._playing = false;
        ILaya.stage.off(Event.BLUR, this, this.onBlur);
        if (this._loaded)
            this.onPause();
    }
    resume() {
        this.play();
    }
    setLoaded() {
        this._loaded = true;
        this.onTransformChanged();
        if (this._playing)
            this.onPlay();
    }
    getNodeTransform() {
        let trans;
        if (Browser.onTTMiniGame) {
            trans = SpriteUtils.getGlobalPosAndScale(this._owner);
            trans.x *= ILaya.stage.clientScaleX;
            trans.y *= ILaya.stage.clientScaleY;
            trans.scaleX *= ILaya.stage.clientScaleX;
            trans.scaleY *= ILaya.stage.clientScaleY;
        }
        else
            trans = SpriteUtils.getTransformRelativeToWindow(this._owner, 0, 0);
        return { x: trans.x, y: trans.y, width: Math.round(this._owner.width * trans.scaleX), height: Math.round(this._owner.height * trans.scaleY) };
    }
    onTransformChanged() {
    }
    destroy() {
        this.onDestroy();
        this.attachTo(null);
        ILaya.stage.off(Event.BLUR, this, this.onBlur);
    }
    onBlur() {
        if (!this.allowBackground)
            PAL.media.resumeUntilGotFocus(this);
    }
    onLoad(url) {
    }
    onPlay() {
    }
    onPause() {
    }
    onDestroy() {
    }
}
